import { Component, OnInit } from '@angular/core';
import {CoreService} from '../../helper/core/core.service';
@Component({
  selector: 'app-legalnotices',
  templateUrl: './legalnotices.component.html',
  styleUrls: ['./legalnotices.component.scss']
})
export class LegalnoticesComponent implements OnInit {

  public legalNotices = '';
  public errorMsg: string = "";
  public errorApi: boolean = false;

  constructor(
    private coreService: CoreService
  ) { }

  ngOnInit() {
    this.getLegalNotices();
  }

  /**
   * Récupère les mentions légales
   */
   private getLegalNotices() {
    this.coreService.getLegalNotices().subscribe(
      (data) => {

        // Attribution des éléments de la BU
        this.legalNotices = data.legalNotices;
      }, (dataError) => {
        this.errorApi = true;
      }, () => {

      });
  }

}



// WEBPACK FOOTER //
// ./src/app/screens/legalnotices/legalnotices.component.ts